module.exports = __webpack_public_path__ + "static/media/Phantump_gaussian2.cba29422.png";